<div class="calendar-container generic-calendar">

  <div
    class="title d-flex justify-content-between align-items-center">

    <div
      class="d-flex align-items-center w-100"
      style="justify-content: space-around;">

      <!-- MES ANTERIOR -->
      <div
        class="title-prev"
        (click)="prevMes()"
        style="cursor: pointer;">

        <mat-icon>
          chevron_left
        </mat-icon>

      </div>

      <!-- MES ACTUAL -->
      <div
        class="title-month"
        style="font-weight: bold;">

        {{
          viewDate
            | calendarDate:(view + 'ViewTitle'):'es'
        }}

      </div>

      <!-- MES SIGUIENTE -->
      <div
        class="title-next"
        (click)="nextMes()"
        style="cursor: pointer;">

        <mat-icon>
          chevron_right
        </mat-icon>

      </div>

    </div>

  </div>

  <div class="calendar-days">

    <mwl-calendar-month-view
      [style]="'mx-4 !important'"
      [viewDate]="viewDate"
      [events]="events"
      [locale]="locale"
      [refresh]="refresh"
      [weekStartsOn]="weekStartsOn"
      [weekendDays]="weekendDays"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayEnabledClicked($event.day)"
      (beforeViewRender)="beforeMonthViewRender($event)">

    </mwl-calendar-month-view>

  </div>

  <br>

</div>